import { useGetSecurityPermissionsQuery } from 'src/api/redux';

/**
 * Hook to fetch security permissions for a user using RTK Query
 */
const useGetSecurityPermissions = ({
  companyId,
  userId,
}: {
  companyId: string;
  userId: string;
}) => {
  const { data, error, isLoading, refetch } = useGetSecurityPermissionsQuery(
    { companyId, userId },
    {
      skip: !companyId || !userId,
    }
  );

  return {
    data,
    error,
    isLoading,
    mutate: refetch,
    refetch,
  };
};

export default useGetSecurityPermissions;
